import type { SxProps } from '@mui/material'
import { Box, Tooltip } from '@mui/material'
import React from 'react'
import { useIntl } from 'react-intl'

const MenuCollapseIcon = ({ sx, onClick }: { sx?: SxProps; onClick?: () => void }) => {
  const { formatMessage } = useIntl()
  const label = formatMessage({ id: 'verticalMenu.collapseMenu' })
  return (
    <Tooltip title={label} placement="right" arrow>
      <Box
        component="button"
        type="button"
        aria-label={label}
        onClick={onClick}
        sx={[
          {
            appearance: 'none',
            border: 0,
            m: 0,
            p: 0,
            background: 'none',
            display: 'inline-flex',
            cursor: 'pointer',
            color: 'inherit',
          },
          ...(Array.isArray(sx) ? sx : [sx]),
        ]}
      >
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M13.5 13V5L9.5 9L13.5 13ZM2 18C1.45 18 0.979167 17.8042 0.5875 17.4125C0.195833 17.0208 0 16.55 0 16V2C0 1.45 0.195833 0.979167 0.5875 0.5875C0.979167 0.195833 1.45 0 2 0H16C16.55 0 17.0208 0.195833 17.4125 0.5875C17.8042 0.979167 18 1.45 18 2V16C18 16.55 17.8042 17.0208 17.4125 17.4125C17.0208 17.8042 16.55 18 16 18H2ZM5 16V2H2V16H5ZM7 16H16V2H7V16Z"
            fill="currentColor"
          />
        </svg>
      </Box>
    </Tooltip>
  )
}

export default MenuCollapseIcon
